import { render, staticRenderFns } from "./CommentConfirmContent.vue?vue&type=template&id=375866f8&"
import script from "./CommentConfirmContent.vue?vue&type=script&lang=ts&"
export * from "./CommentConfirmContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports